import { render, staticRenderFns } from "./ProjectLogo.vue?vue&type=template&id=2ceffc4c"
import script from "./ProjectLogo.vue?vue&type=script&lang=js"
export * from "./ProjectLogo.vue?vue&type=script&lang=js"
import style0 from "./ProjectLogo.vue?vue&type=style&index=0&id=2ceffc4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports